// French
export const locale = {
  lang: 'fr',
  data: {
    TRANSLATOR: {
      SELECT: 'choisissez votre langue',
    },
    MENU: {
      NEW: 'Nouveau',
      ACTIONS: 'Actions',
      CREATE_POST: 'Créer un message',
      PAGES: 'Des pages',
      FEATURES: 'Caractéristiques',
      APPS: 'applications',
      DASHBOARD: 'Tableau de bord',
      CALENDAR: 'Calendriers',
      ROOMS: 'Pièces',
      REPORT: 'Défauts de rapport',
      USERSETTINGS: 'Paramètres des utilisateurs',
      SYSTEMSETTINGS: 'Les paramètres du système',
      LOGOCONFIGURATION: 'Configuration du logo',
      EMAILCONFIGURATION: 'Configuration des e-mails',
      EQUIPMENTS: 'Équipements',
      STYLESETTINGS: 'Paramètres de style',
      CONFIGURATIONBYLOCATION: 'Configuration par emplacement',
      ROOMSETTINGS: 'Paramètres de la pièce',
      ACCOUNTINFORMATION: 'Information sur le compte',
      BOOKING: 'Réservation',
      CHECKOUTS: 'Paiements',
      VISITORS: 'Visiteurs',
      VISITS: 'Visites',
      CONFIGURECUSTOMERADMIN: 'Configurer administrateur client',
      MRROOM: 'Mr Chambres',
      ADMMINBACKOFFICE: 'Back Office administratif',
      ADMIN: 'Administrateur',
      MRVISITS: 'Mr Visites',
    },
    ROOMS: {
      LOCATION: 'Emplacement',
      ROOMS: 'Pièces',
      EQUIPMENTS: 'Équipements',
      STARTDATE: 'Date de début',
      ENDDATE: 'Date de fin',
      STARTTIME: 'Heure de début',
      ENDTIME: 'Heure de fin',
      TIMEDURATION: 'Durée du temps',
      ALL: 'Toute',
      MEETINGROOM: 'Salle de réunion',
      DESK: 'Bureau',
      PARKINGSEATS: 'Sièges de stationnement',
      SERVICE: 'Un service',
      PLANT: 'Plante',
      BOOK: 'Livre',
      SERVICES: 'Prestations de service',
      CATERING: 'Restauration',
      ITSUPPORT: 'Support Informatique',
      MOBILEEQUIPMENT: 'Équipement mobile',
      SPECIAL: 'Spéciale',
      COMMINGSOON: 'Bientôt disponible',
      MAPPLANT: 'Carte de l\'usine',
      ROOMBOOKING: 'Réservation de chambre',
      LOCATIONS: 'Emplacement',
      RESOURCES: 'Ressources',
      REQUESTERNAME: 'Nom du demandeur',
      SUBJECT: 'Matière',
      DESCRIPTION: 'La description',
      ADDUSER: 'Ajouter un utilisateur',
      ADDVISITORS: 'Ajouter des visiteurs',
      CATERINGDESCRIPTION: 'Description de la restauration',
      MOBILEEQUIPMENTDESCRIPTION: 'Description de l\'équipement mobile',
      ITSUPPORTDESCRIPTION: 'Description du support informatique',
      SPECIALSERVICE: 'Service spécial',
      SPECIALSERVICEDESCRIPTION: 'Description du service spécial',
      REQUESTEREMAIL: 'Courriel du demandeur',

    },
    ROOMBOOKING: {
      NEWBOOKING: 'Nouvelle réservation',
      LOCATIONS: 'Emplacements',
      BUILDING: 'Building',
      FLOOR: 'Floor',
      RESOURCES: 'Ressources',
      STARTDATE: 'Date de début',
      ENDDATE: 'Date de fin',
      STARTTIME: 'Heure de début',
      ENDTIME: 'Heure de fin',
      TIMEDURATION: 'Durée du temps',
      DESKS: 'Bureaux',
      REQUESTORNAME: 'Nom du demandeur',
      REQUESTOREMAIL: 'Courriel du demandeur',
      SUBJECT: 'Matière',
      ADDUSERS: 'Ajouter des utilisateurs',
      ADDVISITORS: 'Ajouter des visiteurs',
      PARKINGSEATS: 'Sièges de stationnement',
      CATERRING: 'Restauration',
      MOBILEEQUIPMENT: 'Équipements mobiles',
      ITSUPPORT: 'Support Informatique',
      CATERINGDESCRIPTION: 'Description de la restauration',
      MOBILEEQUIPMENTDESCRIPTION: 'Description de l\'équipement mobile',
      ITSUPPORTDESCRIPTION: 'Description du support informatique',
      SPECIALSERVICE: 'Service spécial',
      SPECIALSERVICEDESCRIPTION: 'Description du service spécial',
      BOOK: 'Livre',
      CANCEL: 'Annuler',
      BACK: 'Dos',

      CAPACITY:'Capacity', 
      COMPANY:'Company', 
      VISITORNAME:'Visitor Name',

      DRIVER: 'Driver',
      LICENSEPLATE: 'License Plate',
      USAGETYPE: 'Usage Type',


      EQUIPMENT: 'Équipement',
      STARTDATEISREQUIRED: 'La date de début est requise',
      ENDDATEISREQUIRED: 'La date de fin est obligatoire',
      STARTTIMEISREQUIRED: 'L\'heure de début est requise',
      ENDTIMEISREQUIRED: 'L\'heure de fin est requise',
      ROOMS: 'Pièces',
      DESCRIPTION: 'La description',
      CLEANING: 'Nettoyage',
      CLEANINGDESCRIPTION: 'Cleaning description',
      CHECKROOMAVAILABLITY: 'Vérifier la disponibilité de la chambre',
      EDITBOOKING:'Edit Booking',
      SELECTBUILDING: 'Select Your Building',
      SELECTFLOOR: 'Select Your Floor'
    },

    DASHBOARD: {
      FROM: 'de',
      TO: 'À',
      NOWINUSE: 'Maintenant utilisé',
      FREEROOMS: 'Chambres gratuites',
      FREEDESKS: 'Bureaux gratuits',
      FREEPARKINGSEATS: 'Siège de stationnement gratuit',
      TODAY: 'Aujourd\'hui',
      RESERVATIONSOFROOMS: 'Réservations de chambres',
      RESERVATIONSOFDESKS: 'Réservations de comptoirs',
      RESERVATIONSOFPARKINGSEATS: 'Réservations de places de parking',
      USERSMISSEDCHECKIN: 'Enregistrement manqué par les utilisateurs',
      NORECENTCHECKIN: 'Aucun enregistrement récent',
      CURRENTMONTH: 'Mois en cours',
      RESERVATIONSPERROOM: 'Réservations par chambre',
      RESERVATIONSPERDESK: 'Réservations par bureau',
      PARKINGSEATSRESERVATIONS: 'Réservation de places de parking',
      RESERVATIONSPERUSER: 'Réservations par utilisateur',
      MISSINGRESERVATIONS: 'Réservations manquantes',
      TIMEOFRESERVATIONSPERUSER: 'Heure des réservations par utilisateur',
      TIMEOFRESERVATIONSPERROOM: 'Heure de réservation par chambre',
      TIMEOFRESERVATIONSPERDESK: 'Heure de réservation par bureau',
      TOTALCOSTPERUSER: 'Coût total par utilisateur',
      DOWNLOADASCSVFILE: 'Télécharger en tant que fichier CSV',
    },
    USERSETTINGS: {
      UPLOADCSV: 'Télécharger CSV',
      IMPORTFROMLDAP: 'Importer depuis LDAP',
      AZUREACTIVEDIRECTORY: 'Azure Active Directory',
      SSO: 'SSO',
      ADD: 'Ajouter',
      NAME: 'Nom',
      EMAIL: 'E-mail',
      LOCATION: 'Emplacement',
      ROLE: 'Rôle',
      ACTION: 'action',
      FILTER: 'Filtre',
      CSVFILE: 'Fichier CSV',
      DOWNLOADTEMPLATE: 'Télécharger le modèle',
      UPLOAD: 'Télécharger',

      LDAPSERVER: 'Serveur LDAP',
      PORT: 'Port',
      DISABLETLS: 'Désactiver TLS',
      IMPORT: 'Importer',
      CANCEL: 'Annuler',
      USERNAME: 'Nom d\'utilisateur',
      PASSWORD: 'Mot de passe',
      CHECKCONNECTION: 'Vérifier la connexion',
      LDAPSERVERBASE: 'Base du serveur LDAP',
      LDAPSEARCHFILTER: 'Filtre de recherche LDAP',
      DEFAULTADUSERMAILBOX: 'Filtre de boîte aux lettres utilisateur AD par défaut',
      CUSTOMLDAPFILTER: 'Filtre LDAP personnalisé',
      LDAPRFIDATTRIBUTE: 'Attribut RFID LDAP (facultatif)',
      COUNTRY: 'Pays',
      ADDUSER: 'Ajouter un utilisateur',
      ADDROLES: 'Ajouter des rôles',
      ROLENAME: 'Nom de rôle',
      ACCESSRIGHTS: 'Des droits d\'accès',

    },
    USERACCESSRIGHTS: {
      BOOKABUILDING: 'Réservez un bâtiment',
      BOOKADESK: 'Réservez un bureau',
      ORDERCATERING: 'Commander un traiteur',
      ENDABOOKING: 'Mettre fin à une réservation',
      ACTIVATEINACTIVATE: 'Activer / désactiver les salles de réunion',
      PARKINGCHECKOUT: 'Check-out du parking',
      ACTIVATEINACTIVATEDISPLAYS: 'Activer / désactiver les écrans',
      BOOKAFLOOR: 'Réservez un étage',
      BOOKAPARKINGSEATS: 'Réservez une place de parking',
      ORDERMOBILEEQUIPMENT: 'Commander des équipements mobiles',
      DELETEABOOKING: 'Supprimer une réservation',
      ACTIVATEINACTIVATEDESK: 'Activer / désactiver les bureaux',
      ACTIVATEINATIVATEKIOSKS: 'Activer / désactiver les kiosques',
      ORDERSPECIALSERVICES: 'Commander des services spéciaux',
      BOOKAROOM: 'Réserver une chambre',
      ORDERITSERVICES: 'Commander des services informatiques',
      EDITABOOKING: 'Modifier une réservation',
      EXTENDABOOKING: 'Prolonger une réservation',
      ACTIVATEINACTIVATEPARKINGSEATS: 'Activer / désactiver les sièges de stationnement',
      ACTICATEINACTICATEVIEWPOINTS: 'Activer / désactiver les points de vue',

    },
    LOGOCONFIGURATION: {
      ENABLELOGOCHANGES: 'Activer les changements de logo',
      UPLOADLOGO: 'Télécharger le logo',
      URL: 'URL',
      OR: '(OU ALORS)',
      SAVE: 'Sauvegarder',
    },
    EMAILCONFIGURATION: {
      EMAILCONFIGURATION: 'Configuration des e-mails',
      EMAIL: 'E-mail',
      PASSWORD: 'Mot de passe',
      HOSTSERVER: 'Serveur-hôte',
      PORT: 'Port',
      CHECKEMAIL: 'Vérifier le courrier',
      SAVE: 'Sauvegarder',
      TOEMAIL: 'Envoyer un email',
    },
    STYLESETTINGS: {
      SYSTEMSTYLE: 'Style de système',
      SIDEBUTTONCOLOR: 'Couleur du bouton latéral',
      ACTIONBUTTONCOLOR: 'Couleur du bouton d\'action',
      TOPTITLES: 'Titres les plus populaires',
      TEXTCOLOR: 'Couleur du texte',
      BACKGROUNDCOLOR: 'Couleur de l\'arrière plan',
      KIOSKCHECKINSTYLE: 'Style d\'enregistrement au kiosque',
      BACKGROUNDIMAGE: 'Image de fond',
      KIOSKINFORMATION: 'Informations sur le kiosque',
      SERVICESVIEWPOINTSDISPLAYINFORMATION: 'Informations d\'affichage des points de vue des services',
      SAVE: 'Sauvegarder',
      CANCEL: 'Annuler',
      RESTORETODEFAULT: 'Rétablir les options par défaut',
    },

    CONFIGURATIONBYLOCATION: {
      SEARCHHERE: 'Cherche ici',
      COUNTRY: 'Pays',
      LOCATION: 'Emplacement',
      TIMEZONE: 'Fuseau horaire',
      ACTIONS: 'Actions',
    },
    EQUIPMENTS: {
      EQUIPMENTALIGNMENT: 'Alignement des équipements',
      SEARCHHERE: 'Cherche ici',
      ICON: 'Icône',
      TITLE: 'Titre',
      ACTION: 'action',
      LEFT: 'La gauche',
      RIGHT: 'Droit',
      TOP: 'Haut',
      BOTTOM: 'Bas',
      ADD: 'Ajouter',
    },
    ACCOUTINFORMATION: {
      COMPANYNAME: 'Nom de la compagnie',
      CONTACTNAME: 'Nom du contact',
      PHONENUMBER: 'Numéro de téléphone',
      COUNTRY: 'Pays',
      RESELLER: 'Revendeur',
      EMAILTOREGISTRATION: 'Envoyer un e-mail à l\'inscription',
      TYPEOFACCOUNT: 'Type de compte:',
      NUMBEROFROOMS: 'Nombre de chambres',
      NUMBEROFROOMSDISPLAYS: 'Nombre d\'affichages de pièces',
      NUMBEROFDESKS: 'Nombre de bureaux',
      NUMBEROFDESKSDISPLAYS: 'Nombre d\'affichages de pupitres',
      NUMBEROFPARKINGSPACES: 'Nombre d\'espaces de stationnement',
      NUMBEROFSERVICESVIEWPOINTS: 'Nombre de points de vue de services',
      NUMBEROFKIOSKS: 'Nombre de kiosques',
      ACCOUNTID: 'Identifiant de compte',
      VALIDFROM: 'Valide à partir de',
      VALIDTO: 'Valable pour',
      CONTACTSUPPORT: 'Contactez le support',
      MESSAGE: 'Un message',
      CLOSE: 'Fermer',
      SEND: 'Envoyer',
    },
    LOGINGPAGE: {
      WELCOMETOMRROOMS: 'Bienvenue chez MrRooms',
      NEWHERE: 'Nouveau ici?',
      DEMOACCOUNT: 'Compte démo',
      ENTERYOURDETAILSTOCREATEYOURACCOUNT: 'Entrez vos coordonnées pour créer votre compte',
      COMPANYNAME: 'Nom de la compagnie',
      CONTACTNAME: 'Nom du contact',
      PHONE: 'Téléphoner',
      COUNTRY: 'Pays',
      CONFIRMPASSWORD: 'Confirmez le mot de passe',
      ACCEPTTERMSCONDITIONS: 'Accepter les termes et conditions',
      TERMSANDCONDITIONS: 'termes et conditions',
      EMAIL: 'E-mail',
      PASSWORD: 'Mot de passe',
      FORGOTPASSWORD: 'mot de passe oublié',
      DISCOVERAMAZINGWORKSPACE: 'Découvrez Amazing Workspace',
      SERVICEVIEWPOINTS: 'Points de vue du service',
      KIOSKSMAPPLANTS: 'Plantes de carte de kiosques',
      ENTERYOUREMAILTORESETYOURPASSWORD: 'Entrez votre e-mail pour réinitialiser votre mot de passe',
      SUBMIT: 'Soumettre',
      CANCEL: 'Annuler',
      SIGNIN: 'S\'identifier',
      EMAILIDISREQUIRED: 'L\'identifiant de messagerie est requis',
      PASSWORDISREQUIRED: 'Mot de passe requis',
      THELOGINDETAILSAREINCORRECT: 'Les informations de connexion sont incorrectes',
      COMPANYNAMEISREQUIRED: 'Le nom de l\'entreprise est obligatoire',
      NAMEISREQUIRED: 'Le nom est requis',
      PHONENUMBERISREQUIRED: 'Le numéro de téléphone est requis',
      COUNTRYISREQUIRED: 'Le pays est requis',
      EMAILISREQUIRED: 'Email est requis',
      CONFIRMPASSWORDISREQUIRED: 'Confirmer le mot de passe est requis',
      ACCEPTTSCSISREQUIRED: 'Accepter les conditions générales est requis',
    },
    CALENDAR: {

      TODAY: 'Aujourd\'hui',
      MEETINGROOMS: 'Salle de réunion',
      DESK: 'Bureau',
      PARKINGSEATS: 'Sièges de stationnement',
      MONTH: 'Mois',
      WEEK: 'Semaine',
      DAY: 'Jour',
      SUNDAY: 'dimanche',
      MONDAY: 'lundi',
      TUESDAY: 'Mardi',
      WEDNESDAY: 'Mercredi',
      THURSDAY: 'jeudi',
      FRIDAY: 'Vendredi',
      SATURDAY: 'samedi',
    },
  }
};
